import { render } from "./EdicionSolicitudArticulo.vue?vue&type=template&id=788efdc4&scoped=true"
import script from "./EdicionSolicitudArticulo.vue?vue&type=script&lang=js"
export * from "./EdicionSolicitudArticulo.vue?vue&type=script&lang=js"

import "./EdicionSolicitudArticulo.vue?vue&type=style&index=0&id=788efdc4&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788efdc4"]])

export default __exports__